import * as React from 'react';

import classNames from 'classnames';

import { ISpinnerProps } from './types';

import * as s from './Spinner.scss';

export const Spinner = (props: ISpinnerProps ) => {
	const {
		className,
		size = 24,
		color,
	} = props;

	return <svg
		style={{
			width: `${size}px`,
			height: `${size}px`,
			color,
		}}
		className={classNames(className, s.svg)}
		viewBox="0 0 100 100"
		xmlns="http://www.w3.org/2000/svg"
	>
		<circle stroke="currentColor" className={s.svgCircle} cx="50" cy="50" r="43"/>
	</svg>;
};

